// @flow
import React from 'react';
import Banner from 'app/common/react/ui/Banner';
import i18n from 'app/common/lib/i18n';

type HeroProps = {|
  color?: 'blue' | 'darkGray',
  completeButtonText?: string,
  completeButtonUrl?: string,
  completeButtonUrlInNewTab?: boolean,
  dismissButtonText?: string,
  handleComplete?: Function,
  handleDismiss?: Function,
  header?: string,
  headerSubtitle?: string,
|};

export function Hero({
  color,
  completeButtonText,
  completeButtonUrl,
  completeButtonUrlInNewTab,
  dismissButtonText,
  handleComplete = () => {},
  handleDismiss = () => {},
  header = '',
  headerSubtitle = '',
}: HeroProps) {
  return (
    <Banner
      message={(header + ' ' + headerSubtitle).trim()}
      dismissButtonText={dismissButtonText || i18n._('Close', 'Closing a Hero banner')}
      completeButtonText={completeButtonText || i18n._('Go', 'Completing the Hero banner')}
      completeUrl={completeButtonUrl}
      onComplete={handleComplete}
      onDismiss={handleDismiss}
      useNewTab={completeButtonUrlInNewTab}
      color={color}
    />
  );
}

export default Hero;
